import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import RecruiterLayout from '../components/RecruiterLayout';
import CompanyAnalyticsTab from '../components/CompanyAnalyticsTab';

const CompanyAnalytics = () => {
  const { userProfile } = useAuth();
  const orgId = userProfile?.organizationId;

  return (
    <RecruiterLayout title="Analytics" subtitle="Recruitment performance across your company">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="company-analytics-page">
        {orgId ? (
          <CompanyAnalyticsTab orgId={orgId} companyName={userProfile?.organizationName} />
        ) : (
          <p className="text-sm text-slate-500">No company linked to your account.</p>
        )}
      </div>
    </RecruiterLayout>
  );
};

export default CompanyAnalytics;
